export default __webpack_public_path__ + "static/media/biochar-icon.13878edf.svg";